export function RectIcon() {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor">
      <path d="M15,6L15,14C15,14.552 14.552,15 14,15L6,15C5.448,15 5,14.552 5,14L5,6C5,5.448 5.448,5 6,5L14,5C14.552,5 15,5.448 15,6ZM13,7L7,7L7,13L13,13L13,7Z" />
    </svg>
  );
}
